import { apiGet } from '../services/api'

export interface SiteConfig {
  name: string
  slogan: string
  copyright: string
  startYear: number
}

export const configApi = {
  // 获取站点配置
  getSiteConfig: (): Promise<{ errormsg: string; errorcode: string; data: SiteConfig }> => {
    return apiGet<{ errormsg: string; errorcode: string; data: SiteConfig }>('/config/site')
  }
}
